import { Modal } from 'antd'
import CardImage from 'components/Card/CardImage'
import { Notifier } from 'components/Notifier'
import { COLOR_CONSTANTS } from 'constants/color.constants'
import { ROUTE_CONSTANTS } from 'constants/routes.constants'
import { STATUS } from 'constants/status.constant'
import React from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import LDImage from 'stories/Image'
import { Headder } from 'stories/Typography'
import { formatDate, TIME_DURATION_MAP, UTCTimeConverter } from 'utils'
import { imagePath } from 'utils/assetHelper'

const ConfirmFreeSessionModal = ( props ) => {
    const { show, handleClose, result, selectedSlot, activeDuration, dataForMeeting, purchaseId, code, mobileNumber } = props
    const dispatch = useDispatch()
    const history = useHistory()
    const JoinButton = ({ children, className, onClick, disabled }) => {
        return (
          <button onClick={onClick} className={className} disabled={disabled}>
            {children}
          </button>
        );
      };

      const handleFreeBooking = ()=>{
        const _mobile_number = `${code.code}${mobileNumber}`
        const country = code.countryInitials
        const payload = {
          ...dataForMeeting,
          mobile_number:  _mobile_number,
          country
        }
        const _payload = !purchaseId ? payload : dataForMeeting
        dispatch.payment.requestInitiateSessionPurchase(_payload, (status, data, message)=>{
          if(STATUS.includes(data?.statusCode)){
            const _sessionData = data?.data || {}
            const redurectURLToken = `${ROUTE_CONSTANTS?.BOOKING_CONFIRMED}/${_sessionData?.meeting_id}?_t=${_sessionData?.token}`;
            const redurectURLWithoutToken = `${ROUTE_CONSTANTS?.BOOKING_CONFIRMED}/${_sessionData?.meeting_id}`;
            const url = _sessionData?.token ? redurectURLToken  : redurectURLWithoutToken;
            // history.push(url)
            history.push({
              pathname: url,
              // search: data?.token && `?_mn=${purchaseDetails?.customer_phone}`,
              state: data,
            });
          }else{
            Notifier(status, message)
            handleClose?.()
            // history?.push(window.location.pathname)
          }
        })
      }

  return (
    <Modal
    className=""
    visible={show}
    closable={true}
    onCancel={handleClose}
    centered
    width={400}
    footer={null}
    maskClosable={false}
    bodyStyle={{
      backgroundColor: COLOR_CONSTANTS.SIDEBAR_SELECTED,
      borderRadius: "10px",
    }}
    maskStyle={{
      backdropFilter: "blur(3px)",
      "-webkit-backdrop-filter": "blur(3px)",
    }}
    >
      <div className="text-left">
            <div className="text-left">
             <Headder className="leading-[1.5] text-white text-[20px] text-center">Reviewing Booking</Headder>
            </div>
            <div className="flex flex-col gap-[1rem] justify-start text-white text-[0.8rem] md:text-[1rem] mt-5">
                <div className="flex gap-1 items-center">
                  <CardImage
                    style={{
                      borderRadius: "50%",
                      overflow: "hidden",
                      objectFit: "cover",
                    }}
                    src={
                      result?.profile_image_url || imagePath("/instructors.svg")
                    }
                    className="w-[40px] h-[40px] md:w-[40px] md:h-[40px]"
                  />
                  <span className="text-greeny text-[1.5rem] font-['BWModelica-Medium'] ml-[.7rem]"> {result?.instructor_name}</span>
                </div>
                <div className="flex flex-col gap-[.6rem] items-start font-['BWModelica-Medium']">
                    <div className='flex gap-[.6rem]'>
                        <div className="flex items-center gap-[.7rem]">
                            <LDImage src={imagePath("/calendar.svg")} className="w-[1.5rem]" />
                            {`${formatDate(selectedSlot,"DDMMYYYY")}`}{' ,'}
                        </div>
                        <div className="flex items-center gap-[.7rem]">
                            <LDImage src={imagePath("/clock.svg")} className="w-[1.5rem]" />
                            {`${UTCTimeConverter(selectedSlot)} (${TIME_DURATION_MAP[activeDuration]})`}
                        </div>
                    </div>
                    <div className="flex items-center gap-[.7rem] ml-[5px] text-[#0E896A]">
                        <LDImage src={imagePath("/rupee.svg")} className="w-[.7rem]" />
                        {`Free`}
                    </div>
                </div>
              </div>
         <>
            <div className="flex justify-between mt-5 gap-[1rem]">
              <JoinButton
                className="bg-greeny text-white font-['BWModelica-Medium'] sm:px-[1.5rem] px-[.2rem] md:py-[.6rem] py-[.6rem] w-full rounded-lg text-[14px] font-medium text-center"
                onClick={handleFreeBooking}
              >
                Book session
              </JoinButton>
              <JoinButton
                className="bg-red-400 text-white sm:px-[1.5rem] px-[.2rem] font-['BWModelica-Medium'] md:py-[.6rem] py-[.6rem] w-full rounded-lg text-[14px] font-medium text-center"
                onClick={handleClose}
              >
                Cancel
              </JoinButton>
            </div>
            </>
        </div>
    </Modal>
  )
}

export default ConfirmFreeSessionModal